export class CaptchaChallengeError extends Error {
  readonly cause: unknown;

  constructor(cause: unknown) {
    super(cause instanceof Error ? cause.message : 'Captcha failed');
    this.name = 'CaptchaChallengeError';
    this.cause = cause;
  }
}

type CaptchaProtectedOperationOptions<T> = {
  captchaRequired: boolean;
  requestCaptchaToken: () => Promise<string>;
  resetCaptchaToken: () => void;
  operation: (captchaToken: string | undefined) => Promise<T>;
};

export async function executeCaptchaProtectedOperation<T>({
  captchaRequired,
  requestCaptchaToken,
  resetCaptchaToken,
  operation,
}: CaptchaProtectedOperationOptions<T>): Promise<T> {
  let captchaToken: string | undefined;

  if (captchaRequired) {
    try {
      captchaToken = await requestCaptchaToken();
    } catch (error) {
      resetCaptchaToken();
      throw new CaptchaChallengeError(error);
    }
  }

  try {
    return await operation(captchaToken);
  } finally {
    if (captchaRequired) {
      resetCaptchaToken();
    }
  }
}
